const url = {
  login: `/api/login/login`,
  // 菜单
  menu: `./api/index/indexMenu`,
  // 常见病/保健
  diseases: `/api/commodity/progress/diseaseAndHealthList`,
  // 会员级别
  storeMemberGrade: `/api/shop/store/getStoreMemberGrade`,
  // 产品，特殊项目，理疗
  productList: `/api/commodity/progress/productList`,
  // 上架下架
  upShelf: `/api/commodity/progress/upShelf`,
  // 修改价格
  upMassagetPrice: `/api/commodity/progress/upMassagePrice`,
  upProductPrice: `/api/commodity/progress/upProductPrice`,
  // 产品大类，精细分类
  type: `/api/commodity/progress/getType`,
  // 添加产品
  addProgress: `/api/commodity/progress/addProgress`,
  // 添加门店推拿--理疗
  addCustom: `/api/commodity/progress/addCustom`,
  // 上传图片
  uploadImg: `/api/photo/photo/uploadImg`,
  // 上传会员表格
  userInto: `/api/parents/member/userInto`,

//上传产品和理疗的表格表格
    excel:`/api/commodity/progress/excel`,


  // 删除产品
  deleteProduct: `/api/commodity/progress/deleteProduct`,
  // 获取手法学位
  getHand: `/api/commodity/progress/getHand`,
  // 获取门店技师级别
  masseurLevel: `/api/masseur/index/getMasseurLevel`,
  // 获取产品
  getProduct: `/api/commodity/progress/getProduct`,
  // 修改产品，
  upProgress: `/api/commodity/progress/upProgress`,
  // 获取门店推拿
  getCustom: `/api/commodity/progress/getCustom`,
  // 修改门店推拿
  upCustom: `/api/commodity/progress/upCustom`,
  // 导出表格
  exportExcel: `/api/commodity/progress/physicalExcel`,
  // 获取门店信息
  shop: `api/shop/store/index`,
  // 修改门店信息
  upShop: `api/shop/store/upShop`,
  getArea: `/api/shop/store/getArea`,
  sendMessage: `/api/login/sendMessage`,
  accountOrShop: `/api/login/getAccountOrShop`,
  upPass: `/api/login/upPass`,
  // 评测

  test: `/api/test/index/index`,
  testChildList: `/api/test/index/babyList`,
  physicalImg: `/api/test/index/physicalImg`,
  heightImg: `/api/test/index/height`,
  weightImg: `/api/test/index/weight`,
  physique: `/api/test/index/physique`,
  physical: `/api/test/index/physical`,
  testResult: `/api/test/index/testResult`,
  getDoctors: '/api/test/index/masseurList',
  testSum: `/api/test/index/testSum`,

  // 会员
  childList: `/api/parents/member/childList`,
  addMember: `/api/parents/member/addMember`, // 5hez
  getSource: `/api/parents/member/getSource`,
  addSource: '/api/parents/member/addSource',
  deleteSource: `/api/parents/member/deleteSource`,
  upMember: `/api/parents/member/upMember`,
  allRecord: `/api/parents/member/allRecord`,
  oneRecord: `/api/parents/member/oneRecord`,
  memberExportExcel: `/api/parents/member/userExcel`,
  getUserDetail: '/api/parents/member/getUserDetail',
  addChild: '/api/parents/member/addMember', // 肖浪，和上面的addMember冲突
  // 咨询
  newChildList: '/api/diagnose/consultation/childList',
  severitySymptomList: `/api/diagnose/consultation/severitySymptom`,
  getHealthInfo: '/api/diagnose/consultation/healthPage',
  childBaseInfo: '/api/diagnose/consultation/getUserLastRecord', // 上次咨询
  saveHealthInfo: '/api/diagnose/consultation/healthJudge', // 保健提交
  getRecord: '/api/diagnose/consultation/getRecord', // 咨询详情
  getCustomList: '/api/diagnose/consultation/getCustomList', // 特色项目获取
  postCustomList: '/api/diagnose/consultation/customPost', // 特色项目提交
  getDiseaseSymptom: '/api/diagnose/consultation/getDiseaseSymptom',
  postDiseaseConfirmed: '/api/diagnose/consultation/diseaseConfirmed',
  symptomsSymptom: '/api/diagnose/consultation/symptomsSymptom',
  postQuickDiagnose: '/api/diagnose/quick/diagnose',
  feedBack: '/api/diagnose/consultation/healthFeedbackPage',
  isFeedBack: '/api/diagnose/consultation/isHealthFeedback',
  saveFeedBack: '/api/diagnose/consultation/healthFeedback',
  saveDetail: '/api/diagnose/consultation/end',
  getChangeRecord: '/api/diagnose/consultation/changeRecord',
  getCustomResult: '/api/diagnose/consultation/customResult',

  // 首页
  total: `/api/home/index/getTotal`,
  birthdayReminderNum: `/api/home/index/birthdayReminderNum`,
  birthdayReminder: `/api/home/index/birthdayReminder`,
  todayNum: `/api/home/index/todayNum`,
  diagram: `/api/home/index/diagram`,
  hotItem: `/api/home/index/hotItem`,
  hotUser: `/api/home/index/hotUser`,

  getTemplate: `/api/index/getTemplate`
};

export {url as default};
